import { Fragment } from 'react';
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import type { SlideOverProps } from './slideOver.types';

export function SlideOver({ isOpen, onClose, title, subtitle, footer, children }: SlideOverProps) {
    return (
        <Transition show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <TransitionChild
                    as={Fragment}
                    enter="ease-out duration-200"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-150"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-raro-gray-900/40" aria-hidden="true" />
                </TransitionChild>

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
                            <TransitionChild
                                as={Fragment}
                                enter="transform transition ease-out duration-200"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transform transition ease-in duration-150"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                            >
                                <DialogPanel className="pointer-events-auto flex h-full w-screen max-w-lg flex-col bg-white shadow-raro-lg">
                                    <div className="flex items-start justify-between gap-4 border-b border-raro-gray-200 px-5 py-4 sm:px-6">
                                        <div className="min-w-0">
                                            <DialogTitle className="font-montserrat text-lg font-semibold text-raro-gray-900">{title}</DialogTitle>
                                            {subtitle && <p className="mt-0.5 text-sm text-raro-gray-500">{subtitle}</p>}
                                        </div>
                                        <button
                                            type="button"
                                            onClick={onClose}
                                            className="rounded-lg p-2 text-raro-gray-400 transition hover:bg-raro-gray-100 hover:text-raro-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-500"
                                            aria-label="Fechar"
                                        >
                                            <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                                        </button>
                                    </div>

                                    <div className="flex-1 overflow-y-auto px-5 py-5 sm:px-6">{children}</div>

                                    {footer && (
                                        <div className="border-t border-raro-gray-200 bg-raro-gray-50 px-5 py-4 sm:px-6">{footer}</div>
                                    )}
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}

export default SlideOver;
